/* Eya Clean Pro — Theme Global Controller */

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initMobileNav();
  initModals();
  initTabs();
  initWishlistUI();
});

// Re-init on Shopify theme editor events
document.addEventListener('shopify:section:load', () => {
  initStickyHeader();
  initMobileNav();
  initModals();
  initTabs();
  initWishlistUI();
});

function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 30) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

function initMobileNav() {
  const trigger = document.querySelector('[data-mobile-menu-trigger]');
  const drawer = document.querySelector('.mobile-nav-drawer');
  const closeBtn = document.querySelector('[data-mobile-menu-close]');
  const overlay = document.querySelector('.mobile-nav-overlay');

  if (!trigger || !drawer) return;

  const openMenu = () => {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  trigger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Close when clicking internal anchor links inside mobile nav
  drawer.querySelectorAll('a[href^="#"], a[href*="#"]').forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeMenu();
    }
  });
}

function initModals() {
  const searchTriggers = document.querySelectorAll('[data-search-trigger]');
  const searchModal = document.querySelector('.search-modal');
  const searchClose = document.querySelector('[data-search-close]');
  const searchOverlay = document.querySelector('.search-modal-overlay');

  if (searchModal) {
    searchTriggers.forEach(btn => btn.addEventListener('click', () => {
      searchModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const input = searchModal.querySelector('input[type="search"], input[type="text"]');
      if (input) setTimeout(() => input.focus(), 150);
    }));

    const closeSearch = () => {
      searchModal.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('is-open')) {
        closeSearch();
      }
    });
  }
}

function initTabs() {
  document.querySelectorAll('.tab-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.tab-item');
      if (item) {
        item.classList.toggle('is-open');
      }
    });
  });
}

function initWishlistUI() {
  const updateWishlistButtons = () => {
    let saved = [];
    try {
      saved = JSON.parse(localStorage.getItem('eya_wishlist') || '[]');
    } catch (e) {
      saved = [];
    }
    document.querySelectorAll('[data-wishlist-handle]').forEach(btn => {
      const handle = btn.dataset.wishlistHandle;
      if (saved.includes(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });

    const badge = document.querySelector('[data-wishlist-count]');
    if (badge) badge.textContent = saved.length;
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.wishlistHandle;
    let saved = [];
    try {
      saved = JSON.parse(localStorage.getItem('eya_wishlist') || '[]');
    } catch (err) {
      saved = [];
    }
    if (saved.includes(handle)) {
      saved = saved.filter(h => h !== handle);
    } else {
      saved.push(handle);
    }
    localStorage.setItem('eya_wishlist', JSON.stringify(saved));
    updateWishlistButtons();
  });

  updateWishlistButtons();
}
